import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../lib/api';
import { TrendingUp, DollarSign, Calendar } from 'lucide-react';
import { formatCurrency } from '../utils/format';

export default function Analytics() {
  const { data } = useQuery({
    queryKey: ['dashboard', 30],
    queryFn: () => analyticsApi.getDashboard(30),
  });

  const dashboard = data?.data?.dashboard;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Analytics & Reports</h1>
        <p className="text-gray-600">
          Insights and statistics about your documents and spending
        </p>
      </div>

      {/* Overview Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="card">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-blue-100 rounded-lg">
              <TrendingUp className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Total Documents</p>
              <p className="text-2xl font-bold text-gray-900">
                {dashboard?.overview?.totalDocuments || 0}
              </p>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-green-100 rounded-lg">
              <DollarSign className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Total Spending</p>
              <p className="text-2xl font-bold text-gray-900">
                {formatCurrency(dashboard?.overview?.totalAmount || 0)}
              </p>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-purple-100 rounded-lg">
              <Calendar className="h-6 w-6 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">This Month</p>
              <p className="text-2xl font-bold text-gray-900">
                {formatCurrency(dashboard?.overview?.recentAmount || 0)}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Reports Section */}
      <div className="card">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Available Reports
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <button className="btn-secondary text-left">
            <div>
              <p className="font-medium">Spending Report</p>
              <p className="text-sm text-gray-600">
                Analyze spending by category and vendor
              </p>
            </div>
          </button>
          <button className="btn-secondary text-left">
            <div>
              <p className="font-medium">Tax Report</p>
              <p className="text-sm text-gray-600">
                Generate tax-ready reports by year
              </p>
            </div>
          </button>
          <button className="btn-secondary text-left">
            <div>
              <p className="font-medium">Export Data</p>
              <p className="text-sm text-gray-600">Export to CSV or Excel</p>
            </div>
          </button>
          <button className="btn-secondary text-left">
            <div>
              <p className="font-medium">Custom Report</p>
              <p className="text-sm text-gray-600">
                Create custom report with filters
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

